import { render } from "./PokemonStats.vue?vue&type=template&id=1fdf57e6&scoped=true"
import script from "./PokemonStats.vue?vue&type=script&lang=js"
export * from "./PokemonStats.vue?vue&type=script&lang=js"

import "./PokemonStats.vue?vue&type=style&index=0&id=1fdf57e6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdf57e6"]])

export default __exports__